import React from "react";
import { SearchOutlined } from "@ant-design/icons";
import { Col, Divider, Form, Input, Modal, Row } from "antd";
import CardBank from "component/cards/payment/bank/card_bank";
import { useBanks, useOptionsBanks } from "hook/finance/withdraw/useWithdraw";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DialogBanks = () => {
  // -------------------------- VAR -----------------------------
  const { handleCancel, handleSearch } = useBanks();
  const { data } = useOptionsBanks();
  const form = Form?.useFormInstance();
  const open = Form?.useWatch("openBank", form) || false;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderSearch = () => {
    return (
      <Input
        placeholder="Tìm kiếm ngân hàng"
        variant="outlined"
        style={{ minHeight: 40 }}
        suffix={<SearchOutlined style={{ color: "#aeaeae" }} />}
        onChange={(e) => handleSearch(e?.target?.value)}
      />
    );
  };

  const renderLists = () => {
    const valid = data?.length > 0;
    if (!valid) return null;
    return (
      <Row gutter={[16, 16]}>
        {data?.map((item, index) => (
          <Col key={item?.bin} xl={24} lg={24} md={24} xs={24}>
            <CardBank data={item} order={index} />
          </Col>
        ))}
      </Row>
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <Modal
      title="Chọn ngân hàng"
      open={open}
      onCancel={() => handleCancel(form)}
      footer={null}
    >
      <Divider style={{ margin: "16px 0px" }} />
      <Row gutter={[16, 16]}>
        <Col xl={24} lg={24} md={24} xs={24}>
          {renderSearch()}
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          {renderLists()}
        </Col>
      </Row>
    </Modal>
  );
};
export default DialogBanks;
